import { Winners } from 'constants/common';
import { INotificationResponse } from 'types';

export enum ACTIONS {
  SAVE_WINNER_TO_STORE = 'SAVE_WINNER_TO_STORE',
}

export interface IWinnerState {
  winner: Winners | null;
}

export type WinnerResult = {
  winner: Winners;
  playerPair: boolean;
  bankerPair: boolean;
};

type OnSaveWinnerToStoreNotificationData = {
  winner: Winners;
};

type OnSaveConfirmedWinnerToStoreNotificationData = {
  winner: Winners;
  playerPair: boolean;
  bankerPair: boolean;
};

export type OnDrawFinishedData = INotificationResponse<OnSaveWinnerToStoreNotificationData>;

export type OnResultConfirmedData =
  INotificationResponse<OnSaveConfirmedWinnerToStoreNotificationData>;
